import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {RootState} from "../../../../redux/store";
import Input from "../../../../Atoms/Input";
import {ChangeEvent} from "react";
import {TextEditor} from "../../../../Atoms/TextEditor";
import {setAdventureDesc, setAdventureName} from "../../../../redux/slices/adventure/adventureSlice";

export const AdventureOverviewTab = () => {
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const dispatch = useAppDispatch();

    return (
        <div>
            <div className='row mt-5 justify-content-center'>
                <div className='col-10'>
                    <Input label='Name des Abenteuers' value={adventure.adventureName} onChange={ (event: ChangeEvent<HTMLInputElement>) => dispatch(setAdventureName(event.target.value))}/>
                </div>
            </div>
            <div className='row mt-3 justify-content-center'>
                <div className='col-10 justify-content-center'>
                    <TextEditor label='Beschreibung' onChange={ (value: string) => dispatch(setAdventureDesc(value))} value={adventure.adventureDesc}/>
                </div>
            </div>
        </div>
    )
}